import BuyerRegistration from './BuyerRegistration';

export default BuyerRegistration;
